import LoginPage from "components/pages/LoginPage";

export default function CaptureLogin(props) {
    return <LoginPage />
}